import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/Footer.tsx");
